module.exports = __webpack_public_path__ + "img/weddings_01_V.604e9a3f.webp";